import { ExternalScheduleFormValues } from '@forms/schedules/external/types';
import { ExternalScheduleDialogType } from './types';

type FormField = keyof ExternalScheduleFormValues;

const commonFields: FormField[] = ['date', 'time', 'taskId'];

export const visibleFields: Record<ExternalScheduleDialogType, FormField[]> = {
  generic: [...commonFields, 'externalContactId', 'extraComment', 'note', 'confirmed'],
  manualConcreteOrder: [
    ...commonFields,
    'externalContactId',
    'extraComment',
    'note',
    'confirmed',
    'materialOptions',
  ],
  concreteDirectOrder: [
    ...commonFields,
    'externalSiteId',
    'id',
    'quantity',
    'isExactQuantity',
    'slump',
    'additive',
    'pourMethod',
    'pourElement',
    'rateType',
    'quantityRate',
    'additionalInformation',
    'note',
  ],
};
